
<ng-container *ngFor="let action of actionButtons">
  <button pButton pRipple [label]="action.label | translate" class="{{action.class}}"
   [icon]="action.icon" (click)="ShowEvent(action)">
</button>
</ng-container>



<!-- Child Components -->
<create-opportunity *ngIf="showCreateOpportunityPopup" [visible]="showCreateOpportunityPopup" (hidePopup)="hideOpportunity($event)"></create-opportunity>

<send-bulk-email *ngIf="showBulkEmailPopup" [visible]="showBulkEmailPopup" [tenantId]="tenantId"
   [columnData]="columnData" [EmailSendType]="EmailSendType" [CampaignSource]="campaignSource" [ReportDataForCampaign]="ReportDataForCampaign"
   [totalRecords]="totalRecords" [selectedAllData]="selectedAllData" (hide)="HideSendEmail($event)">
</send-bulk-email>

<send-bulk-sms *ngIf="showBulkSmsPopup" [visible]="showBulkSmsPopup" [tenantId]="tenantId"
   [columnData]="columnData" [SMSSendType]="SMSSendType" [CampaignSource]="campaignSource" [ReportDataForCampaign]="ReportDataForCampaign"
   [totalRecords]="totalRecords" [selectedAllData]="selectedAllData" (hide)="HideSMSEmail($event)">
</send-bulk-sms>

<send-whatsapp *ngIf="showBulkWhatsAppPopup" [visible]="showBulkWhatsAppPopup" [tenantId]="tenantId"
   [columnData]="columnData" [WhatsAppSendType]="WhatsAppSendType" [CampaignSource]="campaignSource" [ReportDataForCampaign]="ReportDataForCampaign"
   [totalRecords]="totalRecords" [selectedAllData]="selectedAllData" (hide)="HideWhatsAppPopup($event)">
</send-whatsapp>

<task-create *ngIf="showTaskCreate" [visible]="showTaskCreate"  [TaskCreateType]="TaskCreateType" [CampaignSource]="campaignSource" 
  [ReportDataForCampaign]="ReportDataForCampaign" [totalRecords]="totalRecords" [selectedAllData]="selectedAllData" [cltIds]="ClientIds" (hide)="hideTaskCreate($event)">
</task-create>

<!-- Child Components -->
